"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import Clock from "@crehana/compass.icons.outline/Clock";
import { cn } from "../utils.js";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../Select/index.js";
import { HOUR_ARRAY } from "./constants.js";
import { calculateTotalMinutes, generateMinuteArray, getHourData } from "./utils.js";
const TimePickerSelect = ({ className, value, mode = 'a.m/p.m', placeholder, onTimeChange, minuteInterval = 15, disabled, removePortal, size = 's', error, helperText })=>{
    const options = useMemo(()=>{
        const minuteArr = generateMinuteArray(minuteInterval);
        const result = [];
        HOUR_ARRAY.forEach((hour)=>{
            minuteArr.forEach((minute)=>{
                const { hourStr, suffix } = getHourData(hour, mode);
                result.push({
                    value: `${hour}:${minute}`,
                    displayLabel: `${hourStr}:${minute}`,
                    displaySuffix: suffix
                });
            });
        });
        return result;
    }, [
        minuteInterval,
        mode
    ]);
    const handleValueChange = useCallback((newValue)=>{
        const [h, m] = newValue.split(':').map(Number);
        onTimeChange?.(newValue, calculateTotalMinutes(h, m));
    }, [
        onTimeChange
    ]);
    return /*#__PURE__*/ jsxs("div", {
        className: "tw-flex tw-flex-col tw-gap-0.8",
        children: [
            /*#__PURE__*/ jsxs(Select, {
                value: value,
                onValueChange: handleValueChange,
                disabled: disabled,
                children: [
                    /*#__PURE__*/ jsx(SelectTrigger, {
                        className: cn('m' === size && 'tw-h-5.6 tw-font-body3 tw-text-1.6', error && 'tw-border-alert-400 hover:tw-border-alert-400 focus-within:tw-border-alert-400 data-[state=open]:tw-border-alert-400', className),
                        "aria-invalid": error || void 0,
                        renderIcon: ()=>/*#__PURE__*/ jsx(Clock, {
                                className: cn(error ? 'tw-text-alert-400' : 'tw-text-neutral-light-600'),
                                size: 24
                            }),
                        children: /*#__PURE__*/ jsx(SelectValue, {
                            placeholder: /*#__PURE__*/ jsx("span", {
                                className: "tw-text-neutral-light-700",
                                children: placeholder
                            })
                        })
                    }),
                    /*#__PURE__*/ jsx(SelectContent, {
                        removePortal: removePortal,
                        children: options.map((option)=>/*#__PURE__*/ jsxs(SelectItem, {
                                value: option.value,
                                children: [
                                    /*#__PURE__*/ jsx("span", {
                                        className: "tw-inline-block tw-w-4.4",
                                        children: option.displayLabel
                                    }),
                                    /*#__PURE__*/ jsx("span", {
                                        children: option.displaySuffix
                                    })
                                ]
                            }, option.value))
                    })
                ]
            }),
            error && helperText && /*#__PURE__*/ jsx("p", {
                className: "tw-font-caption tw-text-alert-400",
                children: helperText
            })
        ]
    });
};
export { TimePickerSelect };
